import React, { useState } from 'react';
import { CardBody, NavItem, TabContent, TabPane, NavLink, Nav, Row, Card, Col } from "reactstrap";
import classnames from "classnames";
import '../global/GlobalCSS.css'
import VesselCard from 'Components/VesselCard';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import ErrorComponent from 'Components/ErrorComponent';
import Skeleton from '@mui/material/Skeleton';
import VesselCardLoading from 'Components/vesselCardLoading';
import Message from 'Components/Message';

const DashboardFleet = () => {
    /** State variables */
    const [activeSettingsTab, setActiveSettingsTab] = useState('0');
    /** State varibles end */

    /** Funtion to change tab */
    const toggle = (tab: any) => {
        if (activeSettingsTab !== tab) {
            setActiveSettingsTab(tab);
        }
    }

    /** Queries */
    /** Load fleets from fleet master */
    const { data: Fleets, isLoading: FleetsLoading, isError: FleetsError } = useQuery(
        [queryKeyes.masters.Fleets.key],
        async () => {
            return await Get(queryKeyes.masters.Fleets.url())
        },
        {
            enabled: true,
        }
    );
    /** Load fleet's vessels */
    const { data: FleetVessels, isLoading: FleetVesselsLoading, isError: FleetVesselsError } = useQuery(
        [queryKeyes.masters.FleetVessels.key],
        async () => {
            return await Get(queryKeyes.masters.FleetVessels.url())
        },
        {
            enabled: true,
        }
    );
    /** Vessel card details */
    const { data: CardDetails, isLoading: CardDetailsLoading, isError: CardDetailsError } = useQuery(
        [queryKeyes.vessel.VesselCardDetails.key],
        async () => {
            return await Get(queryKeyes.vessel.VesselCardDetails.url())
        },
        {
            enabled: true,
        }
    );
    /** Queries end */
    return (
        <React.Fragment>
            {(FleetsError || FleetVesselsError || CardDetailsError) &&
                <Row>
                    <Col lg={4}>
                        <ErrorComponent message='Unable to load required data!' />
                    </Col>
                </Row>
            }
            {(FleetsLoading || FleetVesselsLoading || CardDetailsLoading) &&
                <Card className='mb-0 container-shadow'>
                    <Row>
                        <Skeleton variant="text" width="95%" height={30} className='mt-2 mr-3' style={{ marginLeft: '3rem' }} />
                        {Array.from({ length: 4 }).map((_, index) => (
                            <Col key={index} lg={3} md={4} sm={6} xs={12} className="mb-3">
                                <VesselCardLoading />
                            </Col>
                        ))}
                    </Row>
                </Card>
            }
            {!(FleetsLoading || FleetVesselsLoading) && !(FleetsError || FleetVesselsError) &&
                <Card className='mb-0 container-shadow'>
                    <CardBody className='pb-0 pt-2'>
                        <Nav tabs className="nav-tabs-custom nav-justified">
                            <NavItem>
                                <NavLink
                                    style={{ cursor: 'pointer' }}
                                    className={classnames({
                                        active: activeSettingsTab === '0',
                                    })}
                                    onClick={() => {
                                        toggle('0');
                                    }}
                                >
                                    <span className="d-block d-sm-none">
                                        <i className="mdi mdi-sail-boat"></i>
                                    </span>
                                    <h6 className="d-none d-sm-block">All</h6>
                                </NavLink>
                            </NavItem>
                            {Fleets.filter((item: any) => item.display === true).length > 0 &&
                                Fleets.filter((item: any) => item.display === true)
                                    .map((fleet: any, index: number) => {
                                        return (
                                            <NavItem key={index}>
                                                <NavLink
                                                    style={{ cursor: 'pointer' }}
                                                    className={classnames({
                                                        active: activeSettingsTab === `${index + 1}`,
                                                    })}
                                                    onClick={() => {
                                                        toggle(`${index + 1}`);
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none">
                                                        <i className="mdi mdi-sail-boat"></i>
                                                    </span>
                                                    <h6 className="d-none d-sm-block">{`${fleet?.fleet_name} (${FleetVessels?.filter((item: any) => item?.fleet_id === fleet?.id)?.length})`}</h6>
                                                </NavLink>
                                            </NavItem>
                                        )
                                    })}
                        </Nav>
                        <TabContent activeTab={activeSettingsTab} className="p-3 pb-0 text-muted">
                            <TabPane tabId='0'>
                                <VesselCard Vessels={CardDetails} />
                            </TabPane>
                            {Fleets.filter((item: any) => item.display === true)
                                .map((fleet: any, index: number) => {
                                    let ValidVessels: any[] = FleetVessels.filter((item: any) => item.fleet_id === fleet.id && item.vessel_checkbox === true);
                                    return (
                                        <TabPane key={index} tabId={`${index + 1}`}>
                                            {CardDetails?.filter((item: any) => {
                                                return ValidVessels?.some((valid: any) => valid.vessel_id === item.vessel_id);
                                            }).length === 0 ?
                                                <Row className='justify-content-center pt-0 p-2'>
                                                    <Message message="No vessels are added in this fleet" type='danger' width='300px' />
                                                </Row> :
                                                <VesselCard Vessels={CardDetails?.filter((item: any) => {
                                                    return ValidVessels?.some((valid: any) => valid.vessel_id === item.vessel_id);
                                                })} />
                                            }
                                        </TabPane>
                                    )
                                })}
                        </TabContent>
                    </CardBody>
                </Card>
            }
        </React.Fragment>
    )
}

export default DashboardFleet